import React, { Component } from 'react';
import { Row, Col, Badge } from 'reactstrap';
import { Link } from "react-router-dom";
import * as moment from 'moment';
import * as FontAwesome from 'react-icons/lib/fa'
import Loader from './../../loader/loader';
import { horoscopeName_en, horoscopes_en, horoscopeDate_en, ratings_en } from './../../../../utils/horoscope_en';
import { horoscopeName_es, horoscopeDate_es, horoscopes_es, ratings_es } from './../../../../utils/horoscope_es';
import { horoscopeName_gr, horoscopes_gr, horoscopeDate_gr, ratings_gr } from './../../../../utils/horoscope_gr';
import { horoscopeName_ee, horoscopes_ee, horoscopeDate_ee, ratings_ee } from './../../../../utils/horoscope_ee';
import { horoscopeName_nl, horoscopes_nl, horoscopeDate_nl, ratings_nl } from './../../../../utils/horoscope_nl';
import { horoscopeName_fr, horoscopes_fr, horoscopeDate_fr, ratings_fr } from './../../../../utils/horoscope_fr';
import { horoscopeName_ar, horoscopes_ar, horoscopeDate_ar, ratings_ar } from './../../../../utils/horoscope_ar';
import { horoscopeName_hu, horoscopes_hu, horoscopeDate_hu, ratings_hu } from './../../../../utils/horoscope_hu';
import { horoscopeName_no, horoscopes_no, horoscopeDate_no, ratings_no } from './../../../../utils/horoscope_no';
import { horoscopeName_pl, horoscopes_pl, horoscopeDate_pl, ratings_pl } from './../../../../utils/horoscope_pl';
import { horoscopeName_vn, horoscopes_vn, horoscopeDate_vn, ratings_vn } from './../../../../utils/horoscope_vn';
import { horoscopeName_se, horoscopes_se, horoscopeDate_se, ratings_se } from './../../../../utils/horoscope_se';
import { horoscopeName_cy, horoscopes_cy, horoscopeDate_cy, ratings_cy } from './../../../../utils/horoscope_cy';
import { horoscopeName_ro, horoscopes_ro, horoscopeDate_ro, ratings_ro } from './../../../../utils/horoscope_ro';

import { FormattedMessage } from 'react-intl';
import './style.css';
import { sendData } from '../../../../analytics/sendData';


class HoroscopeDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            id: '',
            match: [],
            categoryName: 'sun_sign',
            contentLoading: true,
            horoscopeName: '',
            horoscopeDate: '',
            horoscopes: {},
            ratings: []
        }
    }

    componentWillMount(){
        moment.locale();
        const match = [];
        const length = moment().format('D').length;
        const day = moment().format('D').charAt(length - 1);
        const id = this.props.location.state.id;

        let horoscopeName = [], horoscopeDate, horoscopes = {}, ratings = {};
        let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));
        this.setState({ countryCode: countryCode });
        if (countryCode.countryCode === 'es' || countryCode.countryCode === 'mx') {
            horoscopeName = horoscopeName_es;
            horoscopeDate = horoscopeDate_es;
            horoscopes = horoscopes_es;
            ratings = ratings_es;

        } else if (countryCode.countryCode === 'gr') {
            horoscopeName = horoscopeName_gr;
            horoscopeDate = horoscopeDate_gr;
            horoscopes = horoscopes_gr;
            ratings = ratings_gr;
        } else if (countryCode.countryCode === 'ee') {
            horoscopeName = horoscopeName_ee;
            horoscopeDate = horoscopeDate_ee;
            horoscopes = horoscopes_ee;
            ratings = ratings_ee;
        } else if (countryCode.countryCode === 'nl') {
            horoscopeName = horoscopeName_nl;
            horoscopeDate = horoscopeDate_nl;
            horoscopes = horoscopes_nl;
            ratings = ratings_nl;
        } else if (countryCode.countryCode === 'fr') {
            horoscopeName = horoscopeName_fr;
            horoscopeDate = horoscopeDate_fr;
            horoscopes = horoscopes_fr;
            ratings = ratings_fr;
        } else if (countryCode.countryCode === 'hu') {
            horoscopeName = horoscopeName_hu;
            horoscopeDate = horoscopeDate_hu;
            horoscopes = horoscopes_hu;
            ratings = ratings_hu;
        } else if (countryCode.countryCode === 'eg' || countryCode.countryCode === 'ps' || countryCode.countryCode === 'jo') {
            horoscopeName = horoscopeName_ar;
            horoscopeDate = horoscopeDate_ar;
            horoscopes = horoscopes_ar;
            ratings = ratings_ar;
        }
        else if (countryCode.countryCode === 'no' || countryCode.countryCode === 'no') {
            horoscopeName = horoscopeName_no;
            horoscopeDate = horoscopeDate_no;
            horoscopes = horoscopes_no;
            ratings = ratings_no;
        }
        else if (countryCode.countryCode === 'pl') {
            horoscopeName = horoscopeName_pl;
            horoscopeDate = horoscopeDate_pl;
            horoscopes = horoscopes_pl;
            ratings = ratings_pl;
        }
        else if (countryCode.countryCode === 'vn') {
            horoscopeName = horoscopeName_vn;
            horoscopeDate = horoscopeDate_vn;
            horoscopes = horoscopes_vn;
            ratings = ratings_vn;
        }
        else if (countryCode.countryCode === 'se') {
            horoscopeName = horoscopeName_se;
            horoscopeDate = horoscopeDate_se;
            horoscopes = horoscopes_se;
            ratings = ratings_se;
        }
        else if (countryCode.countryCode === 'rs') {
            horoscopeName = horoscopeName_cy;
            horoscopeDate = horoscopeDate_cy;
            horoscopes = horoscopes_cy;
            ratings = ratings_cy;
        }
        else if (countryCode.countryCode === 'ro') {
            horoscopeName = horoscopeName_ro;
            horoscopeDate = horoscopeDate_ro;
            horoscopes = horoscopes_ro;
            ratings = ratings_ro;
        }
        else {
            horoscopeName = horoscopeName_en;
            horoscopeDate = horoscopeDate_en
            horoscopes = horoscopes_en;
            ratings = ratings_en
        }

        match[1] = Math.ceil(Math.abs(id + (day / 9 - 9)));
        match[2] = Math.ceil(Math.abs(id + (day / 9 - 3)));
        match[3] = Math.ceil(Math.abs(id + (day / 9 - 6)));
        const horoscope_Name = horoscopeName[(id)];
        let horoscopeRead = '';
        const selectedHoroscope = horoscopes[horoscope_Name][this.state.categoryName];
        if (countryCode.countryCode === 'es' || countryCode.countryCode === 'mx') {
            horoscopeRead = selectedHoroscope[0]
        } else {
            if (moment().format('D') === '31') {
                horoscopeRead = selectedHoroscope[31]
            } else {

                horoscopeRead = selectedHoroscope[day]
            }
        }
        const rating = [];
        rating['love'] = ratings[horoscope_Name]['love'][day]
        rating['mood'] = ratings[horoscope_Name]['mood'][day]
        rating['money'] = ratings[horoscope_Name]['money'][day]
        rating['career'] = ratings[horoscope_Name]['career'][day]

        this.setState({
            day: day,
            id: id,
            match: match,
            horoscopeNames: horoscopeName,
            horoscopeDates: horoscopeDate,  
            horoscopeName: horoscopeName[(id)],
            horoscopeDate: horoscopeDate[id],
            horoscopes: horoscopes,
            ratings: rating,
            horoscopeReading: horoscopeRead,
            contentLoading: false
        })
        
    }

    fetchHoroscopeReading = (categoryName) => {
        let horoscopeRead = '';
        const selectedHoroscope = this.state.horoscopes[this.state.horoscopeName][categoryName];
        if (this.state.countryCode.countryCode === 'es' || this.state.countryCode.countryCode === 'mx') horoscopeRead = selectedHoroscope[0]    
        else {
            if (moment().format('D') === '31') horoscopeRead = selectedHoroscope[31]
            else horoscopeRead = selectedHoroscope[this.state.day]    
        }
        return horoscopeRead;
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        sendData(this.state.horoscopeName, 'horoscope', 'viewed');
    }

    handleCategory = (category_val) => {
        const reading = this.fetchHoroscopeReading(category_val);
        this.setState({
            categoryName: category_val,
            contentLoading: false,
            horoscopeReading: reading
        })
        sendData(this.state.horoscopeName, 'horoscope', 'engaged');
    }

    getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    handleRating = (rated_star) => {
        let star = [5];
        for (let i = 1; i <= 5; i++) {
            if (i <= rated_star) star[i - 1] = rated_star;
            else star[i - 1] = i;   
        }
        const rating = star.map((rowData, index) => {
            return (
                <span key={index}>
                    <FontAwesome.FaStar className={rowData === (rated_star) ? 'color-star' : 'star'} />
                </span>
            )
        })
        return rating;
    }

    render() {
        let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));
        if (this.state.contentLoading) {
            return <Loader />
        }
        console.log("countryCode",countryCode)
        return (
            <div className="ma-horoscopeDet">
                <div className="ma-horoscopeDet-content">
                    <Row>
                        <Col xs='12' className="hororscopedetail-heading">
                            <div className={(countryCode.countryCode === "eg" || countryCode.countryCode === "ps")? "hororscopedetail-back-btn-arabic":""}>
                                <Link to="/"><img src={require('./../../../assets/images/back-button.png')} className="back-button" /></Link>
                            </div>
                            <div className={(countryCode.countryCode === "eg" || countryCode.countryCode === "ps") ? "heading-title-arabic":"heading-title"}>
                                <h1>{this.state.horoscopeName}</h1>
                            </div>
                        </Col>
                        <Col xs='12' className="hororscopedetail-sign">
                            <div className="box-items" style={{ textAlign: 'center' }}>
                                <div className="item">
                                    <div className="item-img">
                                        <img src={require(`./../../../assets/images/horoscopes/horoscope-icon-${this.state.id}.png`)} alt="" />
                                    </div>
                                    <div className="item-caption">
                                        <p className="text-bold">{this.state.horoscopeName}</p>
                                        <p className="offset-top-0">{this.state.horoscopeDate}</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className="offset-top-30">

                        <Col className='readings-col'>
                            <div>
                                <div className="text-justify" >
                                    <div className="cell-xs-12">
                                        <p className="text-bold text-color big">
                                            <FormattedMessage id="horoscopeRead.title"
                                                defaultMessage="Your today's reading"
                                                description=""
                                                values={{}} /> <span className="todays-date">{moment().format('DD/MM/YYYY')}</span></p>
                                        <p className="offset-top-20">
                                            {this.state.horoscopeReading}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className="range text-left range-xs-center offset-top-20 horoscope-image-margin">
                        <div className='horoscope-image cell-xs-12 cell-md-6 cell-lg-6'>
                            <img src={require('./../../../assets/images/horoscope.jpg')} width='460' height='300' alt="" />
                        </div>
                        {['eg','gr','nl','fr','ps','jo','vn','cy'].includes(countryCode.countryCode) ? null :
                        <div className='horoscope-category cell-xs-12 cell-md-6 cell-lg-6' >
                            <div className="horoscope-category-btn">
                                <Badge key='1'
                                    onClick={() => this.handleCategory('sun_sign')}
                                    className={this.state.categoryName === 'sun_sign' ? "mo-badge mo-badge_selected mo-badge-margin-right" : "mo-badge mo-badge-margin-right"}>
                                    <p><FontAwesome.FaSunO style={{ fontSize: 20 }} /><span>&nbsp;&nbsp;</span>
                                        <FormattedMessage id="horoscopeRead.category.sun_sign"
                                            defaultMessage="SUN SIGN"
                                            description=""
                                            values={{}} /></p>

                                </Badge>
                                <Badge key='2'
                                    onClick={() => this.handleCategory('love')}
                                    className={this.state.categoryName === 'love' ? "mo-badge mo-badge_selected mo-badge-margin-right " : "mo-badge mo-badge-margin-right"}>
                                    <p><FontAwesome.FaHeartO style={{ fontSize: 20 }} /><span>&nbsp;&nbsp;</span>

                                        <FormattedMessage id="horoscopeRead.category.love"
                                            defaultMessage="LOVE"
                                            description=""
                                            values={{}} /></p>

                                </Badge>
                                <Badge key='3'
                                    onClick={() => this.handleCategory('career')}
                                    className={this.state.categoryName === 'career' ? "mo-badge mo-badge_selected mo-badge-margin-right" : "mo-badge mo-badge-margin-right"}>
                                    <FontAwesome.FaBriefcase style={{ fontSize: 20 }} /><span>&nbsp;&nbsp;</span>
                                    <FormattedMessage id="horoscopeRead.category.career"
                                        defaultMessage="CAREER"
                                        description=""
                                        values={{}} />

                                </Badge>
                            </div>
                            { countryCode.countryCode==='se' ?'':<div className="horoscope-category-btn">
                                <Badge key='4'
                                    onClick={() => this.handleCategory('money')}
                                    className={this.state.categoryName === 'money' ? "mo-badge mo-badge_selected mo-badge-margin-right" : "mo-badge mo-badge-margin-right"}>
                                    <FontAwesome.FaMoney style={{ fontSize: 20 }} /><span>&nbsp;&nbsp;</span>
                                    <FormattedMessage id="horoscopeRead.category.money"
                                        defaultMessage="MONEY"
                                        description=""
                                        values={{}} />

                                </Badge>
                                <Badge key='5'
                                    onClick={() => this.handleCategory('health')}
                                    className={this.state.categoryName === 'health' ? "mo-badge mo-badge_selected mo-badge-margin-right" : "mo-badge mo-badge-margin-right"}>
                                    <FontAwesome.FaLeaf style={{ fontSize: 20 }} /><span>&nbsp;&nbsp;</span>
                                    <FormattedMessage id="horoscopeRead.category.health"
                                        defaultMessage="HEALTH"
                                        description=""
                                        values={{}} />

                                </Badge>
                                <Badge key='6'
                                    onClick={() => this.handleCategory('planets')}
                                    className={this.state.categoryName === 'planets' ? "mo-badge mo-badge_selected " : "mo-badge"}>
                                    <FontAwesome.FaGlobe style={{ fontSize: 20 }} /><span>&nbsp;&nbsp;</span>
                                    <FormattedMessage id="horoscopeRead.category.planets"
                                        defaultMessage="PLANETS"
                                        description=""
                                        values={{}} />

                                </Badge>
                            </div>}
                        </div>
                        }
                    </div>
                    <div className="range text-left range-xs-center offset-top-30">
                        <div className='horoscope-match cell-xs-12 cell-md-6'>
                            <div className='horoscope-match-title'>
                                <h1> <FormattedMessage id="horoscopeRead.match.title"
                                    defaultMessage="Today's Match"
                                    description=""
                                    values={{}} /></h1>
                            </div>
                            <div className="box-items">
                                <div className="item">
                                    <div className="item-img">
                                        <img src={require(`./../../../assets/images/horoscopes/horoscope-icon-${this.state.match[1]}.png`)} alt="" />
                                    </div>
                                    <div className="item-caption">
                                        <p className="text-bold">{this.state.horoscopeNames[this.state.match[1]]}</p>
                                        <p className="offset-top-0">{this.state.horoscopeDates[this.state.match[1]]}</p>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="item-img">
                                        <img src={require(`./../../../assets/images/horoscopes/horoscope-icon-${this.state.match[2]}.png`)} alt="" />
                                    </div>
                                    <div className="item-caption">
                                        <p className="text-bold">{this.state.horoscopeNames[this.state.match[2]]}</p>
                                        <p className="offset-top-0">{this.state.horoscopeDates[this.state.match[2]]}</p>
                                    </div>
                                </div>
                                <div className="item">
                                    <div className="item-img">
                                        <img src={require(`./../../../assets/images/horoscopes/horoscope-icon-${this.state.match[3]}.png`)} alt="" />
                                    </div>
                                    <div className="item-caption">
                                        <p className="text-bold">{this.state.horoscopeNames[this.state.match[3]]}</p>
                                        <p className="offset-top-0">{this.state.horoscopeDates[this.state.match[3]]}</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='horoscope-rating cell-xs-12 cell-md-6'>
                            <h1 style={{ textAlign: 'center' }}>
                                <FormattedMessage id="horoscopeRead.rating.title"
                                    defaultMessage="Today's Star Ratings"
                                    description=""
                                    values={{}} />
                            </h1>
                            <div className="rating-container">
                                <div className="rating-childs">
                                    <p className="rating-fontSize">
                                        <FormattedMessage id="horoscopeRead.rating.love"
                                            defaultMessage="Love"
                                            description=""
                                            values={{}} />
                                        </p>
                                    <span >{this.handleRating(this.state.ratings['love'])}</span>
                                </div>
                                <div className="rating-childs">
                                <p className="rating-fontSize">
                                    <FormattedMessage id="horoscopeRead.rating.mood"
                                        defaultMessage="Mood"
                                        description=""
                                        values={{}} />
                                    </p>
                                    <span>{this.handleRating(this.state.ratings['mood'])}</span>
                                </div>
                                <div className="rating-childs">
                                <p className="rating-fontSize">
                                    <FormattedMessage id="horoscopeRead.rating.money"
                                        defaultMessage="Money"
                                        description=""
                                        values={{}} />
                                    </p>
                                    <span >{this.handleRating(this.state.ratings['money'])}</span>
                                    </div>
                                <div className="rating-childs">
                                <p className="rating-fontSize">
                                    <FormattedMessage id="horoscopeRead.rating.career"
                                        defaultMessage="Career"
                                        description=""
                                        values={{}} />
                                    </p>
                                    <span>{this.handleRating(this.state.ratings['career'])}</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}
export default HoroscopeDetail;


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/horoscrpeDetail/horoscopeDetail.js